<script>
  import { onMount } from "svelte";

  export let callbacks;
  export let items;
  export let pagination;
  export let scrollElementId;
  export let itemComponent;
  export let additionalProps;

  // To Do: make this component more flexible, not focused on conversations
  onMount(() => {
    let scrollElement = document.getElementById(scrollElementId);

    function scrollHandler() {
      let scrollPosition = scrollElement.scrollTop,
        elementBottom = scrollElement.getBoundingClientRect().bottom,
        scrollHeightPercent = scrollPosition / elementBottom;

      let showingAllMessages = items.length === parseInt(pagination.totalEntries),
        triggerScrollOnHeight = Math.round(scrollHeightPercent * 100) > 80;

      // if scroll height is > 80% and not all chats are showing, load more chats
      if (triggerScrollOnHeight && !showingAllMessages) {
        pagination.loadMore();
      }
    }

    scrollElement.addEventListener("scroll", scrollHandler);

    // remove scroll handler after component breakdown
    return () => scrollElement.removeEventListener("scroll", scrollHandler);
  });

</script>

<div class="message-window-overflow-scroll" id="chat-messages-container">
  {#each items as conversation}
    {#if conversation.last_message || conversation.newMessage}
      <svelte:component this={itemComponent} {conversation} {callbacks} {...additionalProps} />
    {/if}
  {/each}
</div>
